<template>
  <div class="page-title">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    text: { type: String, require: true, },
  },
}
</script>

<style lang="stylus" scoped>
div.page-title
  display block
  height 32px
  line-height 20px
  text-align left
  font-size 32px !important
  font-style normal
  font-weight bold
  color #F06E2D
  margin 32px 16px 16px 16px
</style>
